import Modal from './_component';

export type { ModalProps } from './_types';

export default Modal;
